'use strict';

(function () {
    const hamburger = document.querySelector('.cc-hamburger');
    const mobileNav = document.getElementById('cc-mobile-nav');

    if (!hamburger || !mobileNav) {
        return;
    }

    function closeMobileNav() {
        mobileNav.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
    }

    function toggleMobileNav() {
        const isOpen = mobileNav.classList.toggle('is-open');
        hamburger.setAttribute('aria-expanded', String(isOpen));
        mobileNav.setAttribute('aria-hidden', String(!isOpen));
        if (isOpen) {
            const firstLink = mobileNav.querySelector('a, button');
            firstLink?.focus();
        }
    }

    hamburger.addEventListener('click', function () {
        toggleMobileNav();
    });

    document.addEventListener('click', function (event) {
        if (
            !mobileNav.contains(/** @type {Node} */ (event.target)) &&
            !hamburger.contains(/** @type {Node} */ (event.target))
        ) {
            closeMobileNav();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
            return;
        }

        if (hamburger.getAttribute('aria-expanded') === 'true') {
            closeMobileNav();
            hamburger.focus();
        }
    });

    initNavSubmenus();

    /* Dropdown (Desktop) + Akkordeon (Mobile) fuer Hauptnav-Punkte mit Unterseiten (z.B.
       "Chip Mäp"). Sichtbarkeit haengt beim Desktop-Dropdown ausschliesslich von aria-expanded ab
       (WAI-ARIA-Disclosure-Pattern, kein CSS-:hover/:focus-within mehr) - ein einziger, konsistenter
       Klick-Ausloeser fuer Maus, Tastatur (Enter/Space auf dem Button) und Touch. */
    function initNavSubmenus() {
        const desktopToggles = document.querySelectorAll('.cc-header__nav-toggle');
        const mobileToggles = document.querySelectorAll('.cc-mobile-nav__toggle');

        function closeAllDesktopSubmenus(except) {
            desktopToggles.forEach(function (toggle) {
                if (toggle !== except) {
                    toggle.setAttribute('aria-expanded', 'false');
                }
            });
        }

        desktopToggles.forEach(function (toggle) {
            toggle.addEventListener('click', function (event) {
                event.stopPropagation();
                const isOpen = toggle.getAttribute('aria-expanded') === 'true';
                closeAllDesktopSubmenus(toggle);
                toggle.setAttribute('aria-expanded', String(!isOpen));
            });
        });

        if (desktopToggles.length) {
            document.addEventListener('click', function () {
                closeAllDesktopSubmenus(null);
            });
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    const openToggle = Array.from(desktopToggles).find(function (toggle) {
                        return toggle.getAttribute('aria-expanded') === 'true';
                    });

                    closeAllDesktopSubmenus(null);

                    if (openToggle) {
                        openToggle.focus();
                    }
                }
            });
        }

        mobileToggles.forEach(function (toggle) {
            toggle.addEventListener('click', function () {
                const item = toggle.closest('.cc-mobile-nav__item');
                if (!item) {
                    return;
                }
                const isOpen = item.classList.toggle('is-open');
                toggle.setAttribute('aria-expanded', String(isOpen));
            });
        });
    }

    initCountUpAnimations();

    function initCountUpAnimations() {
        const counters = document.querySelectorAll('[data-count-up]');
        if (!counters.length || !('IntersectionObserver' in window)) {
            return;
        }

        const observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) {
                        return;
                    }
                    animateCounter(/** @type {HTMLElement} */ (entry.target));
                    observer.unobserve(entry.target);
                });
            },
            { threshold: 0.5 }
        );

        counters.forEach(function (el) {
            observer.observe(el);
        });
    }

    function animateCounter(el) {
        const target = parseInt(el.dataset.countUp, 10);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            el.textContent = String(target);
            return;
        }

        const duration = 2000;
        const start = performance.now();

        function step(now) {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(eased * target);

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    /* Hero flush mit Section-Content ausrichten */
    function syncContentLeft() {
        const ref = document.querySelector('.cc-header__inner');
        if (!ref) {
            return;
        }
        const left = ref.getBoundingClientRect().left;
        document.documentElement.style.setProperty('--content-left', left + 'px');
    }
    syncContentLeft();
    window.addEventListener('resize', syncContentLeft);
}());
